import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject, _templateObject2;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { StickyContainer, Sticky } from 'react-sticky';
import { ColorTokens } from '@vds-tokens/color';
import { Line } from '@vds-core/lines';
var propTypes = {
  /**
   * String, React Component, or HTML to render content of AccordionItem
   */
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.node]).isRequired,

  /**
   * @ignore
   */
  onClick: PropTypes.func,

  /**
   * @ignore
   */
  activeID: PropTypes.string,

  /**
   * @ignore
   */
  groupIndex: PropTypes.number,

  /**
   * @ignore
   */
  groupId: PropTypes.string,

  /**
   * Use prop to programmatically control if the AccordionItem is open or closed.
   */
  opened: PropTypes.bool,

  /**
   * @ignore
   */
  type: PropTypes.oneOf(['single', 'multi']),

  /**
   * Use prop to programmatically control if the AccordionItem is sticky when open and scrolled to the top of the page.
   */
  sticky: PropTypes.bool,

  /**
   * @ignore
   */
  testMode: PropTypes.bool,

  /**
   * When true, the drawer will remain open and not be able to close.
   */
  alwaysOpen: PropTypes.bool,

  /**
   * Set the styling of the component to the desktop, tablet, or mobile size based on passed prop. Desktop and tablet are the same size.
   */
  viewport: PropTypes.oneOf(['desktop', 'mobile', 'tablet']),

  /**
   * @ignore
   */
  bottomLine: PropTypes.bool,

  /**
   * @ignore
   */
  topLine: PropTypes.bool,

  /**
   * @ignore
   * Set bottom line to type primary for 1.0
   */
  bottomLinePrimary: PropTypes.bool,

  /**
   * @ignore
   */
  surface: PropTypes.oneOf(['light', 'dark']),

  /**
   * Allows a string to be provided for analytics.
   */
  'data-analyticstrack': PropTypes.string,

  /**
   * Allows a string to be provided for analytics.
   */
  'data-track': PropTypes.string,

  /**
   * Allows a string to be provided for ignoring analytics tagging.
   */
  'data-track-ignore': PropTypes.string,

  /**
   * Allows a string to be provided for click stream.
   */
  'data-clickstream': PropTypes.string,

  /**
   * Allows a string to be provided for analytics tagging.
   */
  'data-sitecat-level': PropTypes.string,

  /**
   * Allows a string to be provided for analytics tagging.
   */
  'data-sitecat-position': PropTypes.string,

  /**
   * Allows a string to be provided for analytics tagging.
   */
  'data-sitecat-datatrack': PropTypes.string,

  /**
   * Allows a string to be provided for analytics tagging.
   */
  'data-sitecat-cta': PropTypes.string
};
var defaultProps = {
  onClick: function onClick() {},
  activeID: null,
  groupIndex: 1,
  groupId: null,
  surface: 'light',
  opened: false,
  type: 'multi',
  sticky: false,
  testMode: false,
  alwaysOpen: false,
  bottomLine: true,
  topLine: true,
  bottomLinePrimary: false //1.0

};
var ComponentWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "ComponentWrapper",
  componentId: "VDS__sc-h2bqgc-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  width: 100%;\n"])));
var StyledAccordionItem = /*#__PURE__*/styled.div.withConfig({
  displayName: "StyledAccordionItem",
  componentId: "VDS__sc-h2bqgc-1"
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  background-color: ", ";\n  padding-bottom: 1px;\n"])), function (_ref) {
  var surface = _ref.surface;
  return surface === 'dark' ? ColorTokens.background.primary.dark.value : ColorTokens.background.primary.light.value;
});

var AccordionItem = /*#__PURE__*/function (_Component) {
  _inherits(AccordionItem, _Component);

  var _super = _createSuper(AccordionItem);

  function AccordionItem() {
    var _this;

    _classCallCheck(this, AccordionItem);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "accordionDetailElement", false);

    _defineProperty(_assertThisInitialized(_this), "state", {
      openedState: _this.props.alwaysOpen ? true : _this.props.opened
    });

    _defineProperty(_assertThisInitialized(_this), "deactivateGroup", function () {
      _this.setState(function () {
        return {
          openedState: false
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "toggleGroup", function () {
      _this.setState(function (_ref2) {
        var openedState = _ref2.openedState;
        return {
          openedState: _this.props.alwaysOpen ? true : !openedState
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "_onClick", function (e, childClick) {
      childClick && childClick(e, !_this.state.openedState);

      _this.toggleGroup();

      if (_this.props.onClick && _this.props.groupId) _this.props.onClick(_this.props.groupId);
    });

    _defineProperty(_assertThisInitialized(_this), "renderDetail", function (childElement, index) {
      var _this$props = _this.props,
          groupId = _this$props.groupId,
          surface = _this$props.surface,
          viewport = _this$props.viewport;
      return /*#__PURE__*/React.cloneElement(childElement, {
        key: index + 1,
        alwaysOpen: _this.props.alwaysOpen,
        opened: _this.props.alwaysOpen || _this.state.openedState,
        groupId: groupId,
        viewport: viewport,
        surface: surface
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderSummary", function (childElement, index) {
      var _this$props2 = _this.props,
          groupIndex = _this$props2.groupIndex,
          groupId = _this$props2.groupId,
          surface = _this$props2.surface,
          sticky = _this$props2.sticky,
          testMode = _this$props2.testMode,
          topLineType = _this$props2.topLineType,
          viewport = _this$props2.viewport,
          analyticsTrack = _this$props2['data-analyticstrack'],
          track = _this$props2['data-track'],
          trackIgnore = _this$props2['data-track-ignore'],
          clickStream = _this$props2['data-clickstream'],
          cta = _this$props2['data-sitecat-cta'],
          dataTrack = _this$props2['data-sitecat-datatrack'],
          position = _this$props2['data-sitecat-position'],
          level = _this$props2['data-sitecat-level'];

      var _ref3 = childElement && childElement.props,
          _onClick = _ref3.onClick; // Check if we are Rendering a Sticky AccordionHeader


      if (sticky) {
        return /*#__PURE__*/React.createElement(Sticky, {
          topOffset: 0
        }, function (_ref4) {
          var style = _ref4.style;
          return /*#__PURE__*/React.cloneElement(childElement, {
            key: index + 1,
            alwaysOpen: _this.props.alwaysOpen,
            opened: _this.state.openedState,
            onClick: function onClick(e, x) {
              _this._onClick(e, x, _onClick);
            },
            groupIndex: groupIndex,
            groupId: groupId,
            surface: surface,
            style: style,
            sticky: sticky,
            testMode: testMode,
            clickStream: clickStream,
            analyticsTrack: analyticsTrack,
            trackIgnore: trackIgnore,
            track: track,
            dataTrack: dataTrack,
            cta: cta,
            position: position,
            level: level,
            topLineType: topLineType,
            viewport: viewport
          });
        });
      } // Render AccordionHeader without Sticky wrapper


      return /*#__PURE__*/React.cloneElement(childElement, {
        key: index + 1,
        alwaysOpen: _this.props.alwaysOpen,
        opened: _this.state.openedState,
        clickStream: clickStream,
        analyticsTrack: analyticsTrack,
        track: track,
        dataTrack: dataTrack,
        trackIgnore: trackIgnore,
        cta: cta,
        position: position,
        level: level,
        onClick: function onClick(e) {
          _this._onClick(e, _onClick);
        },
        groupIndex: groupIndex,
        groupId: groupId,
        surface: surface,
        topLineType: topLineType,
        viewport: viewport
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderGroup", function () {
      var _this$props3 = _this.props,
          children = _this$props3.children,
          groupId = _this$props3.groupId,
          surface = _this$props3.surface,
          topLine = _this$props3.topLine,
          bottomLine = _this$props3.bottomLine,
          topLineType = _this$props3.topLineType,
          bottomLinePrimary = _this$props3.bottomLinePrimary,
          alwaysOpen = _this$props3.alwaysOpen;
      return /*#__PURE__*/React.createElement(ComponentWrapper, null, topLine && /*#__PURE__*/React.createElement(Line, {
        type: !!topLineType ? 'primary' : 'secondary',
        surface: surface
      }), /*#__PURE__*/React.createElement(StyledAccordionItem // aria-expanded={this.state.opened}
      , {
        groupId: groupId,
        surface: surface
      }, React.Children.map(children, function (child, index) {
        // Accordion Children can have a React.Fragment wrapper
        // If so, we need to strip it off
        var childElement = child.type === React.Fragment ? child.props.children : child;
        childElement = childElement instanceof Array ? childElement[0] : childElement; // We only want to save Refs to AccordionHeader and AccordionItem

        var childType = childElement.type.componentType ? childElement.type.componentType : '';

        if (childType === 'AccordionHeader') {
          return _this.renderSummary(childElement, index);
        }

        if (childType === 'AccordionDetail') {
          return _this.renderDetail(childElement, index);
        } // If not an Accordion Component, just return the childElement


        return childElement;
      })), bottomLine && /*#__PURE__*/React.createElement(Line, {
        type: bottomLinePrimary ? 'primary' : 'secondary',
        surface: surface
      }));
    });

    return _this;
  }

  _createClass(AccordionItem, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var activeID = prevProps.activeID,
          type = prevProps.type;
      var isOpened = this.props.alwaysOpen ? true : this.props.opened;

      if (type === 'single' && this.props.activeID !== activeID && prevState.openedState && !this.props.alwaysOpen) {
        this.deactivateGroup();
      }

      if (typeof isOpened !== 'undefined' && this.props.opened !== prevProps.opened) {
        this.setState({
          openedState: this.props.opened
        });
        this.props.onClick && this.props.onClick(this.props.groupId);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          groupId = _this$props4.groupId,
          sticky = _this$props4.sticky,
          testMode = _this$props4.testMode;

      if (sticky) {
        return /*#__PURE__*/React.createElement(StickyContainer, {
          "data-testid": testMode ? "stickycontainer_".concat(groupId) : undefined,
          "sticky-div": "stickyDiv"
        }, this.renderGroup());
      }

      return this.renderGroup();
    }
  }]);

  return AccordionItem;
}(Component);

_defineProperty(AccordionItem, "componentType", 'AccordionItem');

AccordionItem.propTypes = propTypes;
AccordionItem.defaultProps = defaultProps;
export default AccordionItem;